package top.wcpe.allincore.dsl.ir.model.statemachine

/**
 * 状态机的一条状态迁移定义。
 *
 * M10 引入：当当前状态匹配 [from]（`null` 表示通配）且目标为 [to] 时，
 * 用本条记录中的时长 / 缓动驱动属性过渡。Codec 中 `from==null` 编码为空串。
 *
 * @see UiStateMachine
 */
class UiSmTransition(
    // val 属性生成 getFrom()/getTo()/getDurationMs()/getDelayMs()/getEasing()，与原 Java getter 名一致。
    /** 起始状态名；`null` 表示「任意状态」通配匹配。 */
    val from: String?,
    /** 目标状态名，非空。 */
    val to: String,
    /** 迁移持续时长（毫秒），非负。 */
    val durationMs: Long,
    /** 迁移延迟（毫秒），非负。 */
    val delayMs: Long,
    /** 缓动函数名（与 [top.wcpe.allincore.dsl.ir.model.animation.UiAnimation] 复用同一命名空间）。 */
    val easing: String,
) {

    init {
        require(durationMs >= 0L) { "durationMs 必须非负: $durationMs" }
        require(delayMs >= 0L) { "delayMs 必须非负: $delayMs" }
    }

    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other !is UiSmTransition) return false
        return durationMs == other.durationMs &&
            delayMs == other.delayMs &&
            from == other.from &&
            to == other.to &&
            easing == other.easing
    }

    // 逐位复刻 Objects.hash(from, to, durationMs, delayMs, easing)：种子 1、31 倍累乘，null 记 0。
    override fun hashCode(): Int {
        var result = 1
        result = 31 * result + (from?.hashCode() ?: 0)
        result = 31 * result + to.hashCode()
        result = 31 * result + durationMs.hashCode()
        result = 31 * result + delayMs.hashCode()
        result = 31 * result + easing.hashCode()
        return result
    }

    override fun toString(): String =
        "UiSmTransition{" + (from ?: "*") + "->" + to +
            ",durationMs=" + durationMs +
            ",delayMs=" + delayMs +
            ",easing=" + easing + "}"
}
